var React = require('react');

function DifficultyLevel (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M18 3c-2.297 0-4.477.494-6.451 1.367A11.94 11.94 0 0 0 6 3C2.686 3 0 5.684 0 9c0 2.903 1.718 5.324 4 5.879v5.12C4 20.55 4.45 21 5 21h14c.55 0 1-.45 1-1V14.19c2.39-1.038 4-2.972 4-5.191 0-3.316-2.685-6-6-6m-2 10H9v2h7c.691 0 1.359-.073 2-.197V19H6v-5.691l-1.528-.373C3.062 12.592 2 10.9 2 8.999c0-2.205 1.794-4 4-4 1.149 0 2.264.204 3.317.574a16 16 0 0 0-2.63 2.114L8.1 9.1A13.9 13.9 0 0 1 18 4.999c2.207 0 4 1.795 4 4 0 2.17-2.747 4-6 4z"}));
}

DifficultyLevel.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = DifficultyLevel;

DifficultyLevel.default = DifficultyLevel;
